'use client';
import { PageHero } from '@/components/general/PageHero';
import PageWrapper from '@/components/general/PageWrapper';
import ViewportWrapper from '@/components/structure/ViewportWrapper';
import React from 'react';
import AboutHero from './AboutHero';
import AboutStats from './AboutStats';
import AboutUsContent from './AboutUsContent';
import MainIcons from '@/icons/main';
import { avatarBg, avatarBgGlow } from '@/functions/formats';
import { Features } from '../../home/HomeContent/Features/Features';
import TeamCard from './TeamCard';
import AboutUsBanner from './AboutUsBanner';

export default function AboutContent() {
  const sampleUser = { name: 'مریم رضایی' };
  const userList = Array.from({ length: 4 }, (_, index) => ({
    ...sampleUser,
    id: index + 1,
    bg: avatarBg(index),
    role: 'مدیر محصول',
  }));
  const whyFeat = {
    kicker: 'ارزش‌های ما',
    title: 'به چه چیزی پایبندیم',
    cards: [
      {
        icon: <MainIcons.shieldIcon />,
        t: 'اعتماد و امنیت',
        d: 'اطلاعات کاربران با بالاترین استانداردهای امنیتی محافظت می‌شود و پرداخت‌ها کاملاً امن است.',
        bg: 'var(--green-bg)',
        fill: 'var(--green)',
      },
      {
        icon: <MainIcons.flashIcon />,
        t: 'سرعت و سادگی',
        d: 'هر خدمتی در کارا در کمترین گام و کوتاه‌ترین زمان انجام می‌شود؛ بدون بروکراسی و پیچیدگی.',
        bg: 'var(--danger-bg)',
        fill: 'var(--danger)',
      },
      {
        icon: <MainIcons.hearthIcon />,
        t: 'کاربرمحوری',
        d: 'همهٔ تصمیم‌های ما بر اساس نیاز واقعی رانندگان گرفته می‌شود؛ محصول ما با بازخورد شما رشد می‌کند.',
        bg: 'var(--purple-bg)',
        fill: 'var(--purple)',
      },
    ],
  };
  const team = {
    kicker: 'تیم ما',
    title: 'آدم‌هایی که کارا را می‌سازند',
    cards: userList,
  };
  return (
    <>
      <PageWrapper className={`p-0`}>
        <ViewportWrapper className={`w-full`}>
          <PageHero>
            <AboutHero />
          </PageHero>
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className={`section-light p-0 mt-0`}>
        <ViewportWrapper className={`container py-0`}>
          <AboutStats />
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className={`section-light mt-0 py-0 pt-70`}>
        <ViewportWrapper className={`container `}>
          <AboutUsContent />
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className="mt-0 section-light  mb-4px p-0">
        <ViewportWrapper className={`container py-0`}>
          <Features feat={whyFeat} className="p-0 pt-70" />
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className="mt-0 section-light  mb-4px p-0">
        <ViewportWrapper className={`container py-0`}>
          <Features feat={team}>
            {({ f, index, bg }) => <TeamCard item={f} index={index} />}
          </Features>
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className="mt-0 section-light  mb-4px pt-0">
        <ViewportWrapper className={`container py-0`}>
          <AboutUsBanner />
        </ViewportWrapper>
      </PageWrapper>
    </>
  );
}
